"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILLogo = void 0;
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var brand_config_1 = require("../../configs/brand.config");
var enums_1 = require("../../shared/enums");
var getLogo = function (logo) {
    if (logo === void 0) { logo = enums_1.LogoEnum.MONARCH; }
    // currently only brand logos
    return brand_config_1.brandConfig[logo].logo;
};
var ILLogo = function (props) {
    props = __assign({ 'aria-label': 'logo', alt: 'brand logo' }, props);
    return (react_1.default.createElement(material_1.Box, __assign({}, props, { logo: undefined,
        alt: undefined,
        'data-testid': 'il-logo' }),
        react_1.default.createElement("img", { alt: props.alt, style: { width: '100%' }, src: getLogo(props.logo) })));
};
exports.ILLogo = ILLogo;
